"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeedback = void 0;
var react_1 = require("react");
var FEEDBACK_LIB_TEAM_LINK = 'https://surveys.yandex-team.ru/fb/widget.js';
var FEEDBACK_LIB_LINK = 'https://surveys.yandex.ru/fb/widget.js';
var FEEDBACK_LIB_STAGING_LINK = 'https://pythia-staging.common.yandex.ru/fb/widget.js';
var getFeedbackLibUrl = function (environment) {
    var isYandexTeamDomain = window.location.host.includes('.yandex-team.ru');
    switch (environment) {
        case 'development':
            return FEEDBACK_LIB_STAGING_LINK;
        case 'production':
            return isYandexTeamDomain ? FEEDBACK_LIB_TEAM_LINK : FEEDBACK_LIB_LINK;
        default:
            return FEEDBACK_LIB_LINK;
    }
};
function useFeedback(feedbackOwnerId, query, options) {
    var _a = options !== null && options !== void 0 ? options : {}, baseUrl = _a.baseUrl, theme = _a.theme, forceTheme = _a.forceTheme, hideHeader = _a.hideHeader, _b = _a.environment, environment = _b === void 0 ? 'production' : _b, _c = _a.root, root = _c === void 0 ? document.body : _c, uid = _a.uid, lang = _a.lang, testIds = _a.testIds, customParams = _a.customParams, afterInitCb = _a.afterInitCb, supportOldMetrikaCounter = _a.supportOldMetrikaCounter;
    (0, react_1.useEffect)(function () {
        var script = document.createElement('script');
        var cleanup;
        script.src = getFeedbackLibUrl(environment);
        script.async = true;
        script.onload = function () {
            cleanup = Ya.Feedback.App.embed(root);
            Ya.Feedback.App.init(feedbackOwnerId, { baseUrl: baseUrl, theme: theme, forceTheme: forceTheme, hideHeader: hideHeader, uid: uid, lang: lang, testIds: testIds, customParams: customParams, supportOldMetrikaCounter: supportOldMetrikaCounter });
            afterInitCb === null || afterInitCb === void 0 ? void 0 : afterInitCb();
            Ya.Feedback.App.fetch().then(function () {
                Ya.Feedback.App.setDefaultQueryParams(query);
            });
        };
        document.body.appendChild(script);
        return function () {
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
            document.body.removeChild(script);
        };
    }, []);
}
exports.useFeedback = useFeedback;
//# sourceMappingURL=index.js.map